<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false"
    @close="dialogClose">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">
      {{ $t("user_center.account_safe.authenticate_trade.title") }}
    </p>
    <el-form class="mt20">
      <el-form-item :label="$t('trade_auth_setting.tip')" prop="operateType">
        <el-radio-group v-model="formData.operateType" style="width: 100%">
          <el-radio :label="0">{{ $t("partner.close") }}</el-radio>
          <el-radio :label="1">{{
            $t("user_center.account_safe.open")
          }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="$t('set_trade_password.password_input')"
        prop="password"
        v-if="formData.operateType === 0"
      >
        <el-input v-model="formData.password" :placeholder="$t('tipsVal.inputPlaceholder')" />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">{{ $t("buy_box.confirm") }}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      nowType: 0,
      formData: {
        operateType: 0,
        password: "",
      },
    };
  },
  created() {
    this.nowType = this.$store.state.user.orderConfirm;
    this.formData.operateType = this.$store.state.user.orderConfirm;
  },
  mounted() {},
  methods: {
    submit() {
      const _this = this;
      if (this.nowType === this.formData.operateType) {
        return false;
      }
      if (
        this.formData.operateType === 0 &&
        this.formData.password.trim() === ""
      ) {
        this.$message({
          type: "error",
          message: this.$t("validate.password_require"),
        });
      } else {
        this.$axios.post("/user/orderConfirm", this.formData).then((res) => {
          if (res.data.code === this.$store.state.errorCode.ok) {
            _this.$message({
              type: "success",
              message: this.$t("trade_auth_setting.success"),
            });
            _this.$store.commit(
              "updateTradeConfirm",
              this.formData.operateType,
            );
            _this.dialogVisible = false;
          } else {
            _this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      }
    },
    dialogClose() {
      this.formData = {
        operateType: 0,
        password: "",
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #4063ff;
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: #4063ff;
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #4063ff;
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #3370ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
